module.exports = __webpack_public_path__ + "img/sidebar-bg.12b1e2e.jpg";